import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

class MoversNav extends Component {

  render() {
    const {
      previousLink,
      nextLink,
      previousText,
      nextText,
      valid,
      externalLink
    } = this.props;

    const nextBtnClass = {
      'x-button--solid' : valid !== false,
      'x-button--disabled' : valid === false,
      'movers-nav-button': true
    };

    return (
      <div className="movers-nav">
        {nextText
          ? nextLink
            ? <Link
                className="x-button--solid movers-nav-button"
                to={nextLink}
                data-tracking="{}"
              >
                {nextText}
              </Link>
            : <button
                type="submit"
                className={classNames(nextBtnClass)}
                data-tracking="{}"
              >
                {nextText}
              </button>
          : null
        }
        {previousLink && previousText
          ? externalLink
            ? <a
                className="x-button--outline movers-nav-button"
                href={previousLink}
                data-tracking="{}"
              >
                {previousText}
              </a>
            : <Link
                className="x-button--outline movers-nav-button"
                to={previousLink}
                data-tracking="{}"
              >
                {previousText}
              </Link>
          : null
        }
      </div>
    );
  }
}

MoversNav.propTypes = {
  previousLink: PropTypes.string,
  nextLink: PropTypes.string,
  previousText: PropTypes.string,
  nextText: PropTypes.string,
  valid: PropTypes.bool,
  externalLink: PropTypes.bool
};

export default MoversNav;



/** WEBPACK FOOTER **
 ** ./client/components/Movers/Common/MoversNav/MoversNav.jsx
 **/